// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6060":"49d91a2203414055","7486":"6bd44ef26c611906"}[chunkId] + ".js";
};